import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    refresh: false,
};

export const vendorRefreshSlice = createSlice({
    name: 'vendorRefresh',
    initialState,
    reducers: {
        setRefresh: (state, action) => {
            state.refresh = action.payload.refresh;
        },
    },
});

export const { setRefresh } = vendorRefreshSlice.actions;
export default vendorRefreshSlice.reducer;
